import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import CommissionTable from './CommissionTable';
import CommissionOverview from './CommissionOverview';
import { commissionType } from './CommissionPropTypes';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';

class Commissions extends React.Component {

  componentWillMount() {
    if (this.props.needFetch) {
      this.props.requestCommission();
    }
  }
  // componentWillReceiveProps(nextProps) {
  //   if (this.props.id !== nextProps.id) {
  //     if (nextProps.id) {
  //       this.props.selectBooking(nextProps.id);
  //     }
  //   } else if (nextProps.id && nextProps.selectedBooking.needFetch) {
  //     this.props.requestBooking(nextProps.id);
  //   }
  // }
  render() {
    if (this.props.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    if (this.props.needFetch || this.props.isFetching) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.id) {
      return (
        <Layout>
          <div>
            {this.props.children}
          </div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="container-fluid">
          <div className="panel proposal-header planner col-sm-12">
            <CommissionOverview commissions={this.props.commissions} />
            <CommissionTable
              commissions={this.props.commissions}
              editCommission={this.props.editCommission}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Commissions.propTypes = {
  commissions: PropTypes.arrayOf(
    PropTypes.shape({ commissionType }),
  ).isRequired,
  id: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  requestCommission: PropTypes.func.isRequired,
  editCommission: PropTypes.func.isRequired,
};

export default Commissions;



// WEBPACK FOOTER //
// src/routes/commissions/components/Commissions.js